module.exports = __webpack_public_path__ + "static/media/honeycombPeople1.9c3b4a88.png";